/**
 * Bottom tab bar for the end-user (client) app. Uses the .tab-bar / .tab-item
 * classes from globals.css.
 */

import { Link, useLocation } from 'react-router';
import { Home, Dumbbell, CalendarDays, MoreHorizontal, Users, ClipboardList, CalendarClock } from 'lucide-react';
import { isTrainerRole } from '@fitplatform/shared';
import { useAuth } from '@/lib/auth';

// Journal moved off the tab bar — it now lives in a home-page section and the
// More menu. Nutrition is reached from its Home-page link (not a tab). The
// Profile tab is labelled "More".
const athleteTabs = [
  { href: '/home', label: 'Home', icon: Home },
  { href: '/workouts', label: 'Workouts', icon: Dumbbell },
  { href: '/calendar', label: 'Calendar', icon: CalendarDays },
  { href: '/profile', label: 'More', icon: MoreHorizontal },
];

const coachTabs = [
  { href: '/coach/clients', label: 'Clients', icon: Users },
  { href: '/coach/programs', label: 'Programs', icon: ClipboardList },
  { href: '/coach/schedule', label: 'Schedule', icon: CalendarClock },
  { href: '/profile', label: 'More', icon: MoreHorizontal },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const tabs = isTrainerRole(user?.role) ? coachTabs : athleteTabs;

  return (
    <nav className="tab-bar" role="navigation" aria-label="Main navigation">
      {tabs.map((tab) => {
        const active = pathname.startsWith(tab.href);
        const Icon = tab.icon;
        return (
          <Link
            key={tab.href}
            to={tab.href}
            className={`tab-item ${active ? 'active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={22} strokeWidth={active ? 2.2 : 1.6} />
            <span>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
